import { Toast } from 'mint-ui'
export default {
    name: 'length',
    config: {},
    install(Vue, installOptions) {
        Vue.directive('length', (el, binding, vnode) => {
            let handler = function(e) {
                var min = 0
                var max = 200
                if (typeof binding.value === 'number') {
                    max = binding.value
                }
                if (typeof binding.value === 'object') {
                    if (binding.value.min) {
                        min = binding.value.min
                    }
                    if (binding.value.max) {
                        max = binding.value.max
                    }
                }
                var title = e.target.getAttribute('title')
                if (e.target.value.length < min) {
                    Toast(`${title || '输入值'}长度不能小于` + min)
                }
                if (e.target.value.length > max) {
                    e.target.value = e.target.value.substring(0, max);
                    vnode.elm.dispatchEvent(new CustomEvent('input'));
                    Toast(`${title || '输入值'}长度不能大于` + max)
                }
            }
            el.addEventListener('change', handler)
        })
    }
}


// WEBPACK FOOTER //
// ./src/directive/length.js